<script>
    import { findNews } from '../../vue-app/api/news';
    import SingleSelector from "../../vue-app/components/SingleSelector.vue";
    import SearchInput from "../../vue-app/components/SearchInput.vue";
    import bus from '../utils/eventBus';
    import normalizeDropdown from '../utils/dropdown';
    
    export default {
        components: {
            "single-selector": SingleSelector,
            "search-input": SearchInput
        },
        props: {
            pageLang: { type: String, default: '' },
            newsTypes: { type: Array, default: () => [] },
            topics: { type: Array, default: () => [] },
            years: { type: Array, default: () => [] },
            yearSection: { type: String, default: '' }
        },
        data() {
            return {
                bus: bus,
                selectedType: null,
                selectedTopic: null,
                selectedYear: null,
                filteredNews: [],
                isLoading: false,
                hasMore: false,
                page: 0,
                pageSize: 10,
                searchQuery: ''
            };
        },
        computed: {
            currentRoute() {
                return (this.$router && this.$router.currentRoute) || {};
            },
            currentQuery() {
                if (this.currentRoute.query) {
                    return this.currentRoute.query;
                }
                const params = new URLSearchParams(window.location.search);
                const q = {};
                params.forEach((v, k) => { q[k] = v; });
                return q;
            },
            showClearAll() {
                return (this.selectedType && this.selectedType.value !== -1) ||
                    (this.selectedTopic && this.selectedTopic.value !== -1) ||
                    (!this.yearSection && (this.selectedYear && this.selectedYear.value !== -1)) ||
                    this.searchQuery !== '';
            },
            showNoResults() {
                return this.filteredNews.length === 0 && !this.isLoading;
            },
            showShowMore() {
                return this.hasMore && !this.isLoading;
            }
        },
        created() {
            this.bus.$on('dropdownChange', (val, id) => {
                if (id === 'newsTypes') this.selectedType = normalizeDropdown(val, this.newsTypes);
                else if (id === 'topics') this.selectedTopic = normalizeDropdown(val, this.topics);
                else if (id === 'years') this.selectedYear = normalizeDropdown(val, this.years);
                this.handleFilterChange();
            });
            window.addEventListener('click', (e) => {
                this.bus.$emit('hideOtherDropdowns', e.target);
            });
        },
        mounted() {
            const params = {
                language: this.pageLang,
                page: this.page,
                pageSize: this.pageSize
            };
            const query = this.currentQuery || {};

            if (query.type) {
                this.getPreselectedType(parseInt(query.type));
                params.typeTagIds = this.selectedType?.value;
            }
            if (query.topic) {
                this.getPreselectedTopic(parseInt(query.topic));
                params.topicTagIds = this.selectedTopic?.value;
            }
            if (this.yearSection) {
                this.selectedYear = { name: this.yearSection, value: parseInt(this.yearSection) };
                params.publishingYears = this.selectedYear.value;
            } else if (query.year) {
                this.getPreselectedYear(parseInt(query.year));
                params.publishingYears = this.selectedYear?.value;
            }
            this.searchNews(params);
        },
        methods: {
            handleFilterChange(isLoadMore) {
                const params = {
                    language: this.pageLang,
                    page: isLoadMore ? this.page : 0,
                    pageSize: this.pageSize,
                };
                const query = {};

                if (this.selectedType && this.selectedType.value !== -1) {
                    params.typeTagIds = this.selectedType.value;
                    query.type = this.selectedType.value;
                }
                if (this.selectedTopic && this.selectedTopic.value !== -1) {
                    params.topicTagIds = this.selectedTopic.value;
                    query.topic = this.selectedTopic.value;
                }
                if (this.selectedYear && this.selectedYear.value !== -1) {
                    params.publishingYears = this.selectedYear.value;
                    if (!this.yearSection) {
                        query.year = this.selectedYear.value;
                    }
                }
                if (this.searchQuery !== '') {
                    params.queryString = this.searchQuery;
                }

                this.$router.push({
                    path: this.currentRoute.path || window.location.pathname,
                    query: query
                }).catch(err => { });

                this.searchNews(params, isLoadMore);
            },
            searchNews(params, isLoadMore) {
                this.isLoading = true;
                findNews(params)
                    .then(response => {
                        this.isLoading = false;
                        if (response !== '') {
                            if (isLoadMore) {
                                this.filteredNews.push(...response.items);
                            } else {
                                this.filteredNews = response.items;
                            }
                            this.hasMore = response.hasMore;
                        }
                    })
                    .catch(() => {
                        this.isLoading = false;
                    });
            },
            onSearchInput(val) {
                this.searchQuery = val;
                this.handleFilterChange();
            },
            handleClearAllClick() {
                this.clearAll();
            },
            clearAll() {
                this.bus.$emit('clearAll');
                this.selectedType = null;
                this.selectedTopic = null;
                if (!this.yearSection) {
                    this.selectedYear = null;
                }
                this.searchQuery = '';
                this.page = 0;
                this.handleFilterChange();
            },
            getNextNews() {
                this.page++;
                this.handleFilterChange(true);
            },
            getPreselectedType(val) {
                this.newsTypes.forEach(type => {
                    if (type.value === val) {
                        this.selectedType = { ...type };
                    }
                });
            },
            getPreselectedTopic(val) {
                this.topics.forEach(topic => {
                    if (topic.value === val) {
                        this.selectedTopic = { ...topic };
                    }
                });
            },
            getPreselectedYear(val) {
                this.years.forEach(year => {
                    if (year.value === val) {
                        this.selectedYear = { ...year };
                    }
                });
            }
        }
    };
</script>